import ApiService, { HTTPMethod } from './api.core'

class ReportsApi {
  async generateBordereuxReport(borderauxStartDate, borderauxEndDate, borderauxIncludeCharges) {
    return await ApiService.fetch(`reports/bordereux`, HTTPMethod.POST, {
      start_date: borderauxStartDate,
      end_date: borderauxEndDate,
      include_price: borderauxIncludeCharges,
    })
  }

  async createExternalPolicy(purchaseDate, effectiveDate, premiumValue, comment) {
    return await ApiService.fetch(`reports/external_policy`, HTTPMethod.POST, {
      purchase_Date: purchaseDate,
      effective_Date: effectiveDate,
      premium_Value: premiumValue,
      comment: comment,
    })
  }
  async updateExternalPolicy(purchaseDate, effectiveDate, premiumValue, comment) {
    return await ApiService.fetch(`reports/external_policy`, HTTPMethod.PUT, {
      purchase_Date: purchaseDate,
      effective_Date: effectiveDate,
      premium_Value: premiumValue,
      comment: comment,
    })
  }
  async deleteExternalPolicy() {
    return await ApiService.fetch(`reports/external_policy`, HTTPMethod.DELETE, {})
  }
  async getExternalPolicy() {
    return await ApiService.fetch(`reports/external_policy`, HTTPMethod.GET)
  }
}

export default new ReportsApi()
